const R = {
  TRAILER: "TRAILER",
  CAR_TRAILER: "CAR_TRAILER",
  BOAT_TRAILER: "BOAT_TRAILER"
}, A = {
  [R.TRAILER]: void 0,
  [R.BOAT_TRAILER]: [839, 58],
  [R.CAR_TRAILER]: [563, 65, 61, 60, 31, 32, 1107]
};
export {
  R as TrailerType,
  A as trailerTypeConfig
};
